import React, {Component} from 'react';
import '../assets/custom.css';
import '../assets/teachers.css';
import '../assets/apps.css';
import REST from '../Shared/REST';
import Helpers from '../Shared/Helpers';

import {Modal} from 'react-bootstrap';
import {Animated} from "react-animated-css";
import {withRouter} from 'react-router-dom';
import {setInterval, clearInterval} from 'timers';
import {Buttons, Buttons1, CountDownComponent, LevelTrackerComponent, LevelAnimation, VideoComponent} from "./Common";
import ProgressModal from "../ProgressModalComponent/ProgressModal";
import "../assets/students/Maze.css";
import ProgressBox from "../ProgressModalComponent/ProgressBox";
import ScoreBox from "../ProgressModalComponent/ScoreBox";
import DialogBox from "../Shared/DialogBox";
import iconCorrect from '../assets/images/modal_correct.png';
import iconIncorrect from '../assets/images/modal_incorrect.png';
import TRACKING from "../Shared/DataTrackingPoints";
import {updateAppStates, updateStudentAccountTab, updateStudentAppsStatus} from "./actions";
import connect from "react-redux/es/connect/connect";


let usedPassages = [];
let windowHeight = window.innerHeight;
let criteria = [1, 1,2, 3, 4, 5, 5, 6, 6, 7, 7, 8];

class MazeComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            responseContent:'',
            active: 0,
            passages: [],
            modalActive:true,
            loadedScores: false,
            initScore:2,
            bestScores:{
                mazeScore:1,
                mazeLevel:1
            }
        };
    }

    async componentDidMount() {
        await Helpers.authorize(this);
        await REST.getBestScores().then(async(response) => {
            if (response.success) {
                await this.setState({
                    loadedScores: true,
                    bestScores:response.body
                });
            }
        });
    }

    handleModalBack = (modalActive) => {
        this.setState({modalActive: modalActive});
    };

    handleBack = () => {
        console.log('HandleBack-Maze');
        window.location.reload();
        this.setState({active: 0});
    };

    handleActive = async (active) => {
        if(active === 3){
            await REST.getMazeRandom().then(async function (response) {
                if (response.success) {
                    await this.setState({
                        passages: response.body.passages
                    });
                }
            }.bind(this), (error) => {
                console.log('Error', error);
            });
        }
        this.setState({active: active});
    };

    handleBeginTest = () => {
        this.setState({active: 3});
    };

    changeLevelScore = (newLevel, newScore) =>{
        this.state.bestScores.mazeLevel = newLevel;
        this.state.bestScores.mazeScore = newScore;
    };

    render() {
        return (
            <div className={this.state.active !== 2 ? "bgGrey MazeContainer" : "bgYellow MazeContainer"}>
                {
                    this.state.active === 0 ?
                        <div>
                            <div className="section appSection bgGrey">
                                <div className="container">
                                    <div className="appContainer maze">
                                        <h1 style={{textAlign: "center",fontSize:'42px'}}>Maze</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 text-center"}>
                                                {
                                                    this.state.loadedScores ?
                                                    <ProgressBox
                                                        appName={"maze"}
                                                        level={this.state.bestScores.mazeLevel}
                                                        step={this.state.bestScores.mazeScore}
                                                        steps={6}
                                                        maxLevel={12}
                                                    /> : null
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons appName={"maze"} maxLevel={12} level={this.state.bestScores.mazeLevel} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                        : null
                }
                {
                    this.state.active === 1 ?
                        <div>
                            <div className={"appSection bgGrey"}>
                                <div className="container">
                                    <Buttons1 demo appName={"maze"} buttonClick = {this.handleActive} recordedSession={this.state.modalActive} currentTabActive={this.state.active}/>

                                    <div className="appContainer maze">
                                        <h1 style={{textAlign: "center", fontSize:'42px'}}>Maze: Show Me</h1>
                                        <div className={"row"} style={{display: "flex", alignItems: "center"}}>
                                            <div className={"col-xs-12 centerBlock"}>
                                                <VideoComponent url={"https://s3.us-east-2.amazonaws.com/uploadbeta/video/maze/Maze_practice.mp4"}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Buttons demo appName={"maze"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                    : null
                }
                {
                    this.state.active === 2 ?
                        <div>
                            <Buttons1 practice appName={"maze"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                            <Tutorial  studentUser={this.props.studentUser} buttonClick = {this.handleActive}  passage={this.state.passages[0]} beginTest={this.handleBeginTest}/>
                            <Buttons appName={"maze"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                    : null
                }
                {
                    this.state.active === 3 ?
                        <div>
                            <Buttons1 appName={"maze"} buttonClick = {this.handleActive} clickBack={this.handleBack} recordedSession={this.state.modalActive} currentTabActive={this.state.active}/>
                            <Content  studentUser={this.props.studentUser} backBtn={this.handleModalBack} changeLevelScore={this.changeLevelScore} passages={this.state.passages}/>
                            <Buttons appName={"maze"} buttonClick = {this.handleActive} currentTabActive={this.state.active}/>
                        </div>
                    : null
                }
            </div>
        )
    }
}

class ContentComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            popupSurvey: false,
            passages: this.props.passages,
            passage: this.props.passages[0],
            selection: {},
            level: 1,
            score: 3,
            time: 60,
            response: [],
            order: [],
            correct: 0,
            error: 0,
            skipped: 0,
            isNewLevel: true,
            finished: false,
            showNext: false,
            errorType: '',
            isOpen:false,
            levelCal: null,
            scoreCalc: null,
            isNewLevelCalc:null,
            animateLevel:false,
            levelType:'',
            stepType:'',
            consecutiveScore:[],
            firstScore:false,
            lastScore: false,
            modalDialog: false,
            responseContent:'',
            randomCorrect: ['Great Job','Well Done','Fantastic','You got it','Perfect','Way to go','Terrific','Excellent','Super','Nice work','Wonderful','Outstanding','Congratulations','That’s right'],
            randomTitle: '',
            responseArr:[],
            stepDir:'UP',
            stepDirNow: null,
            fullArr:[],
            tooFast:false,
            analytics: {
                type: null,
                metadata: null,
            }
        };
        this.timer = 0;
        this.handleSurveyBack = this.handleSurveyBack.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
        this.handleFinished = this.handleFinished.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleLevelAnimationClose = this.handleLevelAnimationClose.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.theEventListener = this.windowResizeListener.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

   async componentDidMount() {
        window.addEventListener('resize', this.theEventListener, true);
        REST.getBestScores().then(async(response) => {
            if (response.success) {
                await this.setState({
                    level: response.body.mazeLevel,
                    score: response.body.mazeScore,
                    order: this.fieldsOrder(),
                    isOpen:false,
                    randomTitle: this.state.randomCorrect[Math.floor(Math.random()*this.state.randomCorrect.length)]
                });
                await this.emptySelection();
                this.startTimer();
            }
        }, (error) => {
            console.log('ResponseError', error);
        });
       await this.setState({
           analytics: {
               type: TRACKING.STUDENT_MAZE_START,
               metadata: {}
           }
       })
       this.handleAnalytics();
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    windowResizeListener = (e) => {
        console.log(windowHeight);
    };

    async emptySelection() {
        let selection = {};
        this.state.order.forEach((o) => {
            selection[o] = {};
        });
        await this.setState({selection: selection});
    }

    fieldsOrder() {
        let regExp = /\([0-9]{1,9}\)/g;
        let txt = this.state.passage.mazecontent;
        return txt.match(regExp);
    }

    async handleSurveyBack(){
        
    }

    startTimer() {
        if(!this.props.practice){
            this.props.backBtn(false);
        }
        this.timer = setInterval(this.countDown, 1000);
    }

    countDown() {
        let seconds = this.state.time - 1;
        this.setState({time: seconds});
        if (seconds === 0) {
            clearInterval(this.timer);
            this.handleFinished();
        }
    }

    handleSelection = (selected, field) => {
        let {selection} = this.state;
        selection[field] = selected;

        this.setState({selection: selection});
    };

    handleFinished(event) {
        const timeStart = 60;
        if(!this.props.practice) {
            this.props.backBtn(true);
        }
        clearInterval(this.timer);
        if(this.state.time > timeStart - 5 && !this.props.practice){
            this.setState({
                tooFast:true,
                finished: true,
                showNext: true
            });
        } else {
            clearInterval(this.timer);
            let {selection, correct, error, skipped, passage} = this.state;
            let errorType = '';
            Object.keys(selection).forEach((key) => {
                let studentResponse = selection[key];
                let correctResponse = passage.fields.filter(o => o.hasOwnProperty(key)).map(o => o.correct)[0];
                let resToSend;
                if (Object.keys(studentResponse).length === 0) {
                    resToSend = 'S';
                    skipped++;
                }
                else if (JSON.stringify(studentResponse) === JSON.stringify(correctResponse)) {
                    resToSend = 'C';
                    correct++;
                }
                else {
                    resToSend = 'E';
                    errorType = errorType.concat(',' + studentResponse.category);
                    error++;
                }
                resToSend = resToSend.concat(correctResponse.category);
                let {response, order} = this.state;
                response.splice(order.indexOf(key), 0, resToSend);
                this.setState({
                    response: response,
                    correct: correct,
                    skipped: skipped,
                    error: error,
                    tooFast:false,
                    errorType: errorType
                });
            });
            let errorLength = errorType.length;
            if(errorLength>0){
                this.setState({errorType: errorType.substring(1, errorLength)});
            }
            let {response} = this.state;
            let arrResp = response;
            let cleanArr = [];
            let fullArr = [];
            let countS = 0;
            for(let i=0; i < arrResp.length; i++ ){
                if(arrResp[i].substring(0,1) === "S"){
                    countS++
                    if(countS === 3){
                        cleanArr.push(null);
                        cleanArr[i-1]=null;
                        cleanArr[i-2]=null;
                    }
                    else{
                        cleanArr.push(arrResp[i].substring(0,1));
                    }
                }
                else{
                    countS = 0;
                    cleanArr.push(arrResp[i].substring(0,1));
                }
            }
            for(let i=0; i < cleanArr.length; i++){
                if(cleanArr[i] === null){
                    cleanArr.splice(i);
                }
            }
            let cor1 = 0;
            let err1 = 0;
            let skp1 = 0;
            for(let i=0; i < cleanArr.length; i++){
                if(cleanArr[i]=== "C"){
                    cor1++;
                }
                if(cleanArr[i]=== "E"){
                    err1++;
                }
                if(cleanArr[i]=== "S"){
                    skp1++;
                }
                this.setState({
                    response: cleanArr,
                    correct: cor1,
                    skipped: skp1,
                    error: err1,
                });

            }
            console.log(cleanArr.splice(1));

            for(let i=0; i < arrResp.length; i++ ){
                        fullArr.push(arrResp[i].substring(0,1));
            }

            console.log(fullArr.splice(1));
            this.setState({fullArr: fullArr.splice(1)});

            this.setState({finished: true}, () => {
                if (this.validateSession()) {
                    if (!this.props.practice) {
                        this.calculateAndUpdateScore();
                    }
                }
            });
        }
    }

    async calculateAndUpdateScore() {
        let {score, level, correct, error, isNewLevel, skipped} = this.state;

        if (correct >= criteria[level-1] ) {
            score = score + 1;
            this.setState({stepDir:'UP'});
            if (skipped == 1 && error ==0 ){
                if(this.state.fullArr.every( (val, i, arr) => val === arr[0] ) ){
                    this.setState({ consecutiveScore: this.state.consecutiveScore.concat(score)});
                }
                else{
                    this.setState({ consecutiveScore: []});
                }
                console.log(this.state.consecutiveScore);
                if (score >= 2) {
                    for (let i = 0; i < this.state.consecutiveScore.length - 1; i++) {
                        if (this.state.consecutiveScore[i] >= this.state.consecutiveScore[i + 1] || Number.isNaN(this.state.consecutiveScore[i]) || Number.isNaN(this.state.consecutiveScore[i + 1])) {
                        }
                        else {
                            /*
                            if (this.state.consecutiveScore.length === 2) {
                                this.setState({consecutiveScore: []});
                                this.setState({levelType: 'LEVEL UP! You Scored 3 times in a row with 100% correct!'});
                                level = level + 1;
                                score = 2;
                                isNewLevel = true;
                            }*/
                        }
                    }
                }
            }
            if (score > 6) {
                this.setState({consecutiveScore: []});
                level = level + 1;
                score = 1;
                this.setState({levelType: 'LEVEL UP'});
                this.setState({lastScore:true});
                if(level == 13){
                    this.setState({levelType: ''});
                }
                isNewLevel = true;
            }
        }
        else {

            score = score - 1;
            this.setState({consecutiveScore: []});
            if (score < 1) {
                if (level >= 2) {
                    let testsAmount = 0;
                    await REST.getMazeScoreCount().then((response) => { //only allow level up in the first 15 tests
                        if (response.success) {
                            testsAmount = response.body;
                            if(testsAmount < 20){  //only allow level up in the first 20 tests
                                level = level - 1;
                                score = 2;
                                this.setState({stepDir:'DOWN'});
                                this.setState({levelType: 'LEVEL DOWN'});
                                isNewLevel = true;
                            }else{
                                score = 1;
                                this.setState({stepDir:null});
                            }
                            console.log('Success', response);
                        } else {
                            console.log('Error', response.msg);
                        }
                    }, (error) => {
                        console.log('Error', error.msg);
                    });
                } else {
                    score = 1;
                    level = 1;
                    this.setState({stepDir:null});
                }
            }else{
                this.setState({stepDir:'DOWN'});
            }
        }

        this.props.changeLevelScore(level, score);

        this.setState({scoreCalc: score, levelCalc: level, isNewLevelCalc: isNewLevel}, () => {
            this.updateScores();
            this.postSession();
        });
    }

    validateSession() {
        if (this.state.time > 55) {
            return false;
        }
        let {response} = this.state;
        if (response.every(o => Object.keys(o).length === 0)) {
            return false;
        }
        for (let i = 0; i < response.length - 2; i++) {
            if (response[i].includes('S') && response[i + 1].includes('S') && response[i + 2].includes('S')) {
                return false;
            }
        }
        return true;
    }

    updateScores() {
        let body = {
            mazeLevel: this.state.levelCalc,
            mazeScore: this.state.scoreCalc
        };
        REST.updateMazeScore(body).then((response) => {
            if (response.success) {
                console.log('Success', response);
            } else {
                console.log('Error', response.msg);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    }

    postSession() {
        let body = {
            passageId: this.state.passage.passageId,
            sessionTime: 60 - this.state.time,
            correctItems: this.state.correct,
            incorrectItems: this.state.error,
            errorType: this.state.errorType,
            studentData: this.state.response.toString(),
            passageLevel: this.state.level,
            duration: 60,
            guid: '',
            startLevel: this.state.level,
            newLevel: this.state.newLevel ? 1 : 0
        };
        REST.postMazeSession(body).then((response) => {
            console.log('Success', response);
        }, (error) => {
            console.log('Error', error);
        });
    }

    handleLevelAnimationClose(){
        this.setState({animateLevel: false});
        this.state.level == 13 ? window.location.reload() : null;
    }

    async handleNext(e) {
        if(this.state.firstScore) {
            this.setState({firstScore: false});
        }
        if(this.state.lastScore){
            this.setState({lastScore:false});
        }
        let myDiv = document.getElementById('passageMazeID');
        myDiv.scrollTop = 0;
        if(this.state.level > this.state.levelCalc){
        }
        else if (this.state.level < this.state.levelCalc){
        }else{
            await this.setState({levelType: 'STAY'});
        }

        await this.setState({
            popupSurvey:false,
            score: this.state.scoreCalc != null ? this.state.scoreCalc : this.state.score,
            level: this.state.levelCalc != null ? this.state.levelCalc : this.state.level,
            isNewLevel: false,
            animateLevel: this.state.levelType==="STAY" ? false : true
        });

        await REST.getMazeRandom().then(async(response) => {
            if (response.success) {
                await this.setState({
                    passages: response.body.passages
                });
            }
        }, (error) => {
            console.log('Error', error);
        });

        await this.setState({
            selection: {},
            response: [],
            correct: 0,
            error: 0,
            skipped: 0,
            time: 60,
            showNext: false,
            passage: this.state.passages[0]
        });
        await this.setState({order: this.fieldsOrder()});
        await this.emptySelection();
        await this.startTimer();
    }

    handleClose(e) {
        if(this.state.correct === 0 && this.state.error === 0){
            this.setState({finished: false, showNext: true});
            this.handleNext();
        }
        if(this.state.level === this.state.levelCalc){
            this.setState({
                score: this.state.scoreCalc != null ? this.state.scoreCalc : this.state.score,
                level: this.state.levelCalc != null ? this.state.levelCalc : this.state.level,
                stepDirNow: this.state.stepDir,
                isNewLevel: false}, () => {
                this.updateScores();
            });
        }
        if(this.state.score == 1 && !this.state.firstScore && this.state.stepDir === "DOWN" && !this.state.tooFast) {
            this.setState({firstScore: true});
        }
        this.setState({finished: false, showNext: true, popupSurvey: true});
        console.log('activate popupSurvey');
        if(this.props.practice){
            this.props.buttonClick(0);
        }
    }

    closeModal(){
        this.setState({isOpen:false});
    }

    render() {
        let {correct, error, level} = this.state;

        let score = correct;
        if (score < 0) {
            score = 0;
        }
        let title;
        let iconSrc;
        if(this.props.practice){
            level = 1;
        }
        if (correct === 0 && error === 0) {
            if(this.state.tooFast){
                title = 'Try Again!';
                iconSrc = null;
            }else {
                title = 'Nothing to score!';
                iconSrc = null;
            }
        } else if (score === 0 || score <  criteria[level - 1]) {
            title = 'Oops. You need to get ' + criteria[level - 1] + ' correct to move up a step';
            iconSrc = iconIncorrect;
        } else {
            title = this.state.randomTitle;
            iconSrc = iconCorrect;
        }

        return (
            <div>
                <div className={!this.props.practice ? "appSection bgGrey" : "appSection bgYellow"}>
                    <DialogBox surveyModal app={'Maze'} userId={this.props.studentUser.id} active={this.state.popupSurvey} surveyBack={this.handleSurveyBack}/>
                    <div className="container">
                        <div className="row">
                            <ParentComponent passage={this.state.passage}
                                             feedback={this.state.showNext}
                                             handleSelection={this.handleSelection}/>
                        </div>
                    </div>
                </div>
                <div className="section">
                    <div className="">
                        <div className="container">
                            <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                            <div className="divBottomRelative tc">
                                <div className={"row tc"}>
                                    <div className={"col-sm-12 hidden-xs hidden-md hidden-lg"}>
                                        {this.state.showNext ?
                                            <a onClick={this.handleNext} className="handBtn" style={{width:150}}>
                                                <span>Try Another</span>
                                            </a> :
                                            <a onClick={this.handleFinished} className="handBtn">
                                                <span>Finished</span>
                                            </a>
                                        }
                                    </div>
                                    <div className={"col-md-5 col-sm-6"}>
                                        <div hidden={this.props.practice}>
                                        <LevelTrackerComponent appName={"maze"} firstScore={this.state.firstScore} lastScore={this.state.lastScore} stepDir={this.state.stepDirNow} level={this.state.level} maxLevel={12} step={this.state.score} steps={6}/>
                                        </div>
                                    </div>
                                    <div className={"col-md-2 hidden-sm"}>
                                        {this.state.showNext && !this.props.practice ?
                                            <a onClick={this.handleNext} className="handBtn" style={{width:150}}>
                                                <span>Try Another</span>
                                            </a> :
                                            <a onClick={this.handleFinished} className="handBtn">
                                                <span>Finished</span>
                                            </a>
                                        }
                                    </div>
                                    <div className={"col-md-5 col-sm-6"}>
                                        <div className={"row pull-right"}>
                                                <CountDownComponent time={this.state.time} sessionTime={60} showTime={10}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal id={"resultBox"} show={this.state.finished}>
                    <div className="modal-content" style={{minWidth: "530px"}}>
                        <div className="modal-header">
                            {iconSrc ?
                                <img src={iconSrc} style={{width:150}} />
                                :
                                null
                            }
                            <h4>{title}</h4>
                        </div>
                        <div className={"modal-body"}>
                            {title !== 'Nothing to score!' && !this.state.tooFast ?
                                <ScoreBox
                                    score={score}
                                    correct={this.state.correct}
                                    incorrect={this.state.error}
                                    skipped={this.state.skipped - 1}/>
                                :
                                null
                            }
                        </div>
                        <div className="modal-footer">
                            <a className="handBtn" onClick={this.handleClose}>
                                <span>Close</span>
                            </a>
                        </div>
                    </div>
                </Modal>
                <Modal id="animateModal" show={this.state.animateLevel}>
                    <div className="modal-content" >
                        <div className={"modal-body"}>
                            <LevelAnimation appName={"maze"} level={this.state.level} maxLevel={12} typeLevel={this.state.levelType} closeAnimation={this.handleLevelAnimationClose}/>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

const Content = withRouter(ContentComponent);

class Tutorial extends Component {

    constructor(props) {
        super(props);
        this.state = {
            passage: this.props.passage,
            testPassage: `{
	"mazecontent": " “Let’ s make (0) cookies! The recipe (3) for flour, eggs, butter, milk, and (1)” said Jan. Chad said, “We need (2) more egg.”",
	"passageTitle": "Cookies",
	"passageId": 644,
	"passageType": "N",
	"version": 7,
	"fields": [{
		"(0)": [{
			"word": "coutout",
			"category": "0"
		}, {
			"word": "see",
			"category": 1
		}, {
			"word": "hear",
			"category": 1
		}],
		"correct": {
			"word": "cutout",
			"category": "0"
		}
	}, {
		"(1)": [{
			"word": "the",
			"category": 1
		}, {
			"word": "her",
			"category": 1
		}, {
			"word": "sugar",
			"category": "0"
		}],
		"correct": {
			"word": "sugar",
			"category": "0"
		}
	}, {
		"(2)": [{
			"word": "flour",
			"category": 1
		}, {
			"word": "she",
			"category": 1
		}, {
			"word": "one",
			"category": "0"
		}],
		"correct": {
			"word": "one",
			"category": "0"
		}
	},
	{
		"(3)": [{
			"word": "hear",
			"category": 1
		}, {
			"word": "see",
			"category": 1
		}, {
			"word": "calls",
			"category": "0"
		}],
		"correct": {
			"word": "calls",
			"category": "0"
		}
	}],
	"totalBlanks": 3
}`
        };
    }

    render() {
        let passages = [];
        passages.push(JSON.parse(this.state.testPassage));
        return (
            <Content studentUser={this.props.studentUser} buttonClick={this.props.buttonClick} passages={passages} practice={true}/>
        );
    }
}

class ParentComponent extends Component {

    handleSelection = (selected, field) => {
        // this.setState({ selection: selected });
        this.props.handleSelection(selected, field);
    };

    render() {
        let regExp = /\([0-9]{1,9}\)/g;
        let txt = this.props.passage.mazecontent;
        let newTxt = txt.split(regExp);
        let firstTxt = newTxt[0];
        let fields = txt.match(regExp);
        let tmpArray = [];
        let firstItem = this.props.passage.fields.filter(o => o.hasOwnProperty(fields[0])).map(o => o.correct.word);
        let secondTxt = newTxt[1];
        tmpArray.push(firstTxt + firstItem + secondTxt);
        for (let i = 1; i < fields.length; i++) {
            let options;
            let correct;
            this.props.passage.fields.forEach(element => {
                if (element.hasOwnProperty(fields[i])) {
                    options = element[fields[i]];
                    correct = element['correct'];
                }
            });
            tmpArray.push(<span key={i}><ChildComponent feedback={this.props.feedback} correct={correct} field={fields[i]}
                                                        options={options} key={this.props.passage.passageId}
                                                        handleSelection={this.handleSelection}/> {newTxt[i + 1]} </span>);
        }
        return (
            <div className="appContainer maze passage" style={{padding:30,paddingTop:5}}>
                <h3 className="tc" style={{marginBottom:0,marginTop:0}}>{this.props.passage.passageTitle}</h3>
                <div id={"passageMazeID"} style={{paddingLeft:30, paddingRight:30}}>
                {tmpArray}
                </div>
            </div>
        );
    }
}

class ChildComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {selected: ''};
        this.handleSelection = this.handleSelection.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
    }

    handleSelection(e) {
        let selected = this.props.options[e.currentTarget.dataset.id];
        this.setState({selected: selected.word});
        this.props.handleSelection(selected, this.props.field);
        e.preventDefault();
    }

    handleRemove(e) {
        this.props.handleSelection('', this.props.field);
        this.setState({selected: ''});
    }

    render() {
        return (
            <div className="mazeOptions">
                {this.props.feedback && this.state.selected === this.props.correct.word ?
                    <div style={{display:"flex",width:"190px"}}>
                        <div className="blankSpace correct" onClick={this.handleRemove}>{this.state.selected}</div>
                        <div className={"fdbkPlus"}></div>
                    </div>: null
                }
                {this.props.feedback && this.state.selected.length>0 && this.state.selected !== this.props.correct.word ?
                    <div style={{display:"flex",width:"190px"}}>
                        <div className="blankSpace error" onClick={this.handleRemove}>{this.state.selected}</div>
                        <div className={"fdbkMinus"}></div>
                    </div>: null
                }
                {this.props.feedback && this.state.selected.length===0 ?
                    <div className="blankSpace skipped" onClick={this.handleRemove}>{this.state.selected}</div>
                    : null
                }
                {!this.props.feedback ?
                    <div className="blankSpace" onClick={this.handleRemove}>{this.state.selected}</div> : null
                }
                {this.props.feedback ?
                    <ul>
                        {this.state.selected !== this.props.options[0].word &&
                        this.props.options[0].word === this.props.correct.word ?
                            <li value={this.props.options[0].word} data-id={0}
                                className="correct">{this.props.options[0].word}</li> : null
                        }
                        {this.state.selected !== this.props.options[0].word &&
                        this.props.options[0].word !== this.props.correct.word ?
                            <li value={this.props.options[0].word} data-id={0}>{this.props.options[0].word}</li> : null
                        }
                        {this.state.selected !== this.props.options[1].word &&
                        this.props.options[1].word === this.props.correct.word ?
                            <li value={this.props.options[1].word} data-id={1}
                                className="correct">{this.props.options[1].word}</li> : null
                        }
                        {this.state.selected !== this.props.options[1].word &&
                        this.props.options[1].word !== this.props.correct.word ?
                            <li value={this.props.options[1].word} data-id={1}>{this.props.options[1].word}</li> : null
                        }
                        {this.state.selected !== this.props.options[2].word &&
                        this.props.options[2].word === this.props.correct.word ?
                            <li value={this.props.options[2].word} data-id={2}
                                className="correct">{this.props.options[2].word}</li> : null
                        }
                        {this.state.selected !== this.props.options[2].word &&
                        this.props.options[2].word !== this.props.correct.word ?
                            <li value={this.props.options[2].word} data-id={2}>{this.props.options[2].word}</li> : null
                        }
                    </ul>
                    :
                    <ul>
                        {this.state.selected === this.props.options[0].word ?
                            null : <li className={"blankOption"} value={this.props.options[0].word} data-id={0}
                                       onClick={this.handleSelection}>{this.props.options[0].word}</li>
                        }
                        {this.state.selected === this.props.options[1].word ?
                            null : <li className={"blankOption"} value={this.props.options[1].word} data-id={1}
                                       onClick={this.handleSelection}>{this.props.options[1].word}</li>
                        }
                        {this.state.selected === this.props.options[2].word ?
                            null : <li className={"blankOption"} value={this.props.options[2].word} data-id={2}
                                       onClick={this.handleSelection}>{this.props.options[2].word}</li>
                        }
                    </ul>
                }
            </div>
        );
    }
}

const bindActionToProps = dispatch => {
    return {
        updateStudentAppStatus: async(results) => await dispatch(updateStudentAppsStatus(results)),
        updateStudentAccountTab:async(tabNum) => await dispatch(updateStudentAccountTab(tabNum)),
        updateAppStates:async(appStates) => await dispatch(updateAppStates(appStates))
    };
};

const mapStateToProps = state => ({
    apps:state.studentReducer.apps,
    tabNum: state.studentReducer.tabNum,
    studentUser: state.studentReducer.studentUser,
    appStates: state.studentReducer.appStates
});

export default connect(mapStateToProps,bindActionToProps)(withRouter(MazeComponent));


// WEBPACK FOOTER //
// ./src/StudentsComponent/Maze1.js